export const getIconColor = (mode: 'dark' | 'light'): string => {
  switch (mode) {
    case 'dark':
      return '#333'
    case 'light':
      return '#FFF'
  }
}
